import { render, staticRenderFns } from "./ModelSuggestionDigest.vue?vue&type=template&id=30acb616&scoped=true&"
import script from "./ModelSuggestionDigest.vue?vue&type=script&lang=ts&"
export * from "./ModelSuggestionDigest.vue?vue&type=script&lang=ts&"
import style0 from "./ModelSuggestionDigest.vue?vue&type=style&index=0&id=30acb616&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30acb616",
  null
  
)

export default component.exports